import React from 'react';
import T from 'prop-types';

import { locationDataProp } from './locationData';

import { MigrateForm } from './MigrateForm';
import { BillingAddressProps, Header, PackageDetails } from './shared';

function PaygMigration(props) {
  const { companyDetails, billingAddress, packageDetails, editAccountLink, locationData, packageId } = props;

  const formDetails = {
    companyName: companyDetails.name,
    billingEmail: companyDetails.billingEmail,
    addressLineOne: billingAddress.lineOne,
    addressLineTwo: billingAddress.lineTwo,
    city: billingAddress.city,
    countryCode: billingAddress.countryCode,
    region: billingAddress.region,
    postCode: billingAddress.postCode,
    vatNumber: companyDetails.vatNumber,
    packageId,
    editAccountLink,
    locationData,
  };

  return (
    <div className="px-4 sm:px-8 md:px-10 lg:px-16 font-normal max-w-screen-xl mx-auto">
      <Header
        title={`Migrate to ${packageDetails.packageName || 'a paid package'}`}
        subTitle="Check details of your package and confirm migration"
      />
      <div className="flex flex-col md:flex-row gap-0 md:gap-8">
        <PackageDetails packageDetails={packageDetails} additionalCSS={'flex-1'} />
        <div className="flex-1 pt-16 md:pt-0">
          <MigrateForm {...formDetails} />
        </div>
      </div>
    </div>
  );
}

PaygMigration.propTypes = {
  companyDetails: T.object,
  billingAddress: BillingAddressProps,
  packageDetails: T.object,
  editAccountLink: T.string,
  locationData: locationDataProp,
  packageId: T.string.isRequired,
};

export { PaygMigration };
